'use client';

import React from 'react';
import useSubmitFormSubmission from '../../utilities/hooks/use-submit-form-submission';
import type { Form } from '../../payload-types';
import FormView from './form-view';

const ContactFormClient: React.FC<{
  form: Form;
  successText?: string | null;
}> = ({
  form,
  successText,
}) => {
    const [result, action, isPending] = useSubmitFormSubmission({ form });

    return (
      <>
        {result?.status === 'success' ? (
          <div className="alert alert-success">
            {successText ?? 'Submitted successfully.'}
          </div>
        ) : null}

        <FormView
          form={form}
          isPending={isPending}
          action={action}
        />
      </>
    );
  };

export default ContactFormClient;
